import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { NextPage } from 'next'

import { env } from '../config/env'

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
export const stripePromise = loadStripe(env.stripeKey)

export const stripeElementsFonts: StripeElementsOptions['fonts'] = [
  {
    family: 'Graphik',
    weight: '300',
    src: `url(${env.baseUrl}/fonts/graphik-regular.woff)`,
    style: 'normal',
  },
]

const options: StripeElementsOptions = {
  fonts: stripeElementsFonts,
}

export const withStripe = <T extends {}>(PageComponent: NextPage<T>) => {
  const WithStripe: NextPage<T> = pageProps => {
    return (
      <>
        <Elements stripe={stripePromise} options={options}>
          <PageComponent {...pageProps} />
        </Elements>
      </>
    )
  }

  return hoistNonReactStatics(WithStripe, PageComponent)
}
